/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useParams } from "react-router-dom";
import HierarchicalChart from "../../Charts/HierarchicalChart";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { IHierarchicalNode } from "../../../utils/interfaces";
function AssetsClassification({ company_id }: { company_id: string }) {
  const { data, isLoading, error } = useFetchData(
    ["/classifications", "fetchAssetClassifications", company_id],
    "/classifications/",
    {
      company_id,
    },
    // @ts-ignore
    {}
  );

  const { id } = useParams();
  return (
    <HierarchicalChart
      company_id={id as string}
      data={data as IHierarchicalNode[]}
      isLoading={isLoading}
      error={error as string}
    />
  );
}

export default AssetsClassification;
